import { createTextMaskInputElement } from "text-mask-core";
import { isNil } from "../../shared";
import { useCallback, useEffect, useRef } from "react";
export function useMaskedInput({
  inputElement,
  mask
}) {
  const maskRef = useRef();
  useEffect(() => {
    if (!isNil(inputElement)) {
      maskRef.current = createTextMaskInputElement({
        guide: false,
        inputElement,
        mask
      });
    }
  }, [inputElement, mask]);
  return {
    onChange: useCallback(() => {
      var _maskRef$current;

      (_maskRef$current = maskRef.current) === null || _maskRef$current === void 0 ? void 0 : _maskRef$current.update();
    }, [maskRef])
  };
}